import { AsyncState } from "src/models";

export abstract class AsyncStore<T extends AsyncStore<any>> {
  errorState: AsyncState<T> = new AsyncState<T>();
  loadingState: AsyncState<T> = new AsyncState<T>();
}
